export default __webpack_public_path__ + "static/media/procomp.824ccc3a.svg";